const portfolioEndpoint = {
  detail: (symbol: string) => `/virtualtrading/portfolio/${symbol}`,
  list: () => '/virtualtrading/portfolio',
};

export default portfolioEndpoint;
